import { dayjs } from '@shared/utils';
import { z } from 'zod';

const MAX_HISTORY_MONTHS = 24;

const selectionOptionSchema = z.object({
  label: z.string(),
  value: z.string(),
});

export const AdminQuestionnaireFilterSchema = z
  .object({
    examCenters: z
      .array(selectionOptionSchema)
      .default([])
      .refine((val) => val.length > 0, { message: 'กรุณาเลือก Exam Center' }),
    startDate: z
      .date()
      .nullable()
      .refine((val) => !!val, { message: 'กรุณาเลือก Start Date' }),
    endDate: z
      .date()
      .nullable()
      .refine((val) => !!val, { message: 'กรุณาเลือก End Date' }),
    questionnaireTemplate: selectionOptionSchema.nullable().refine((val) => !!val, {
      message: 'กรุณาเลือก Template',
    }),
    examCourses: z
      .array(selectionOptionSchema)
      .default([])
      .refine((val) => val.length > 0, { message: 'กรุณาเลือก Exam Course' }),
  })
  .superRefine((data, ctx) => {
    if (data.startDate && data.endDate && data.endDate < data.startDate) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['endDate'],
        message: 'End Date ต้องไม่น้อยกว่า Start Date',
      });
    }

    if (data.startDate && data.endDate) {
      const endTime = dayjs(data.endDate).startOf('day');
      const maxEndTime = dayjs(data.startDate).startOf('day').add(MAX_HISTORY_MONTHS, 'month');
      if (endTime.isAfter(maxEndTime)) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['endDate'],
          message: 'End Date ต้องไม่เกิน 24 เดือนนับจาก Start Date',
        });
      }
    }
  });

export type AdminQuestionnaireFilterFormInput = z.input<typeof AdminQuestionnaireFilterSchema>;
export type AdminQuestionnaireFilterFormOutput = z.output<typeof AdminQuestionnaireFilterSchema>;
